import $ from "jquery";
import {
  handlerStrongPass,
  parseFormData,
  XHRInterceptor,
} from "../utils/utility";

const dashboardProfile = () => {
  const init = () => {
    handlerXhrInterceptor();
    handlerTogglePassword();
  };

  const el = {
    main: ".dashboard-area",
  };

  if (!$(el.main).length) return;

  const handlerXhrInterceptor = () => {
    XHRInterceptor.enable({
      onSend: ({ data, abort }) => {
        const parsedData = parseFormData(data);

        if (parsedData.action === "homey_ajax_password_reset") {
          const isValidForm = handlerResetPassword();
          console.log(`isValidForm`, isValidForm);
          if (!isValidForm) abort();
        }
      },
      // onComplete: ({ response }) => {
      //   const parserResponse = JSON.parse(response);
      // },
    });
  };

  const handlerResetPassword = () => {
    let isValid = true;
    const $newPassInput = $(`#newpass`);
    const $confirmPassInput = $(`#confirmpass`);

    const $msgContainer = $("#password_reset_msgs");

    if (!$newPassInput.val()) {
      isValid = false;

      $msgContainer.empty();
      $msgContainer.append(
        '<p class="error text-danger">Password cannot be empty.</p>'
      );
    }

    if (!$confirmPassInput.val()) {
      isValid = false;

      $msgContainer.empty();
      $msgContainer.append(
        '<p class="error text-danger">Confirm password cannot be empty.</p>'
      );
    }

    if ($newPassInput.val() !== $confirmPassInput.val()) {
      isValid = false;

      $msgContainer.empty();
      $msgContainer.append(
        '<p class="error text-danger">Password and confirm password do not match.</p>'
      );
    }

    const validPassword = handlerStrongPass($newPassInput.val());

    if (!validPassword) {
      isValid = false;

      $msgContainer.empty();
      $msgContainer.append(
        '<p class="error text-danger">The password must contain uppercase, lowercase, number, and symbol (min 8 chars).</p>'
      );
    }

    return isValid;
  };

  const handlerTogglePassword = () => {
    $('.toggle-password').on('click', function() {
      const input = $(this).siblings('input');
      const type = input.attr('type') === 'password' ? 'text' : 'password';
      input.attr('type', type);
    });
  };

  init();
};

try {
  dashboardProfile();
} catch (e) {
  console.error("Error Single Listing: ", e);
}
